(function () {
  'use strict'

  var DURATION = 280

  // Slides `imgEl` out to the left while sliding a new image in from the
  // right, in place of an instant src swap. Returns the <img> element that
  // now represents the "current" image going forward — callers that cache
  // a reference to the image (e.g. `this.img = ...`) must reassign it to
  // this return value.
  function ppSlideImage(imgEl, newSrc, newSrcset) {
    if (!imgEl || !newSrc) return imgEl
    if (imgEl.getAttribute('src') === newSrc) return imgEl

    var container = imgEl.parentElement
    if (!container || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      imgEl.setAttribute('src', newSrc)
      if (newSrcset) imgEl.setAttribute('srcset', newSrcset)
      else imgEl.removeAttribute('srcset')
      return imgEl
    }

    var rect = imgEl.getBoundingClientRect()
    var prevPosition = container.style.position
    var prevOverflow = container.style.overflow
    var prevHeight = container.style.height

    container.style.position = prevPosition || 'relative'
    container.style.overflow = 'hidden'
    if (rect.height) container.style.height = rect.height + 'px'

    var clone = imgEl.cloneNode(true)
    clone.removeAttribute('id')
    clone.setAttribute('src', newSrc)
    if (newSrcset) clone.setAttribute('srcset', newSrcset)
    else clone.removeAttribute('srcset')

    var overlayStyle = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;'
    imgEl.style.cssText += overlayStyle
    clone.style.cssText += overlayStyle + 'transform:translateX(100%);'

    container.appendChild(clone)

    // Force reflow so the initial transform is applied before transitioning
    void clone.offsetWidth

    imgEl.style.transition = 'transform ' + DURATION + 'ms ease'
    clone.style.transition = 'transform ' + DURATION + 'ms ease'
    imgEl.style.transform = 'translateX(-100%)'
    clone.style.transform = 'translateX(0)'

    var done = false
    function finish() {
      if (done) return
      done = true

      if (imgEl.parentElement) imgEl.remove()

      // Promote the clone back to normal flow so it drives the container's
      // layout correctly afterward (window resize, etc.) instead of staying
      // absolutely positioned forever.
      clone.style.position = ''
      clone.style.top = ''
      clone.style.left = ''
      clone.style.width = ''
      clone.style.height = ''
      clone.style.objectFit = ''
      clone.style.transform = ''
      clone.style.transition = ''

      container.style.position = prevPosition
      container.style.overflow = prevOverflow
      container.style.height = prevHeight
    }

    clone.addEventListener('transitionend', finish, { once: true })
    setTimeout(finish, DURATION + 150) // fallback in case transitionend never fires

    return clone
  }

  window.ppSlideImage = ppSlideImage
})()
